import React from 'react'
import Hero from '../components/Hero'
import Projects from '../components/Projects'
import Skills from '../components/Skills'

const Home = () => {
    return (
        <div>
            <Hero />
            <Skills />
            <Projects />
        </div>
    )
}

export default Home;